import "./contact.page.scss";
import coverImage from "../../assets/images/covers/mini/as-class.png";
import { useContext } from "react";
import { LanguageContext } from "../../contexts/language/language.context";

/* ICONS */
import facebookIcon from "../../assets/icons/contacts/facebook.png";
import gmailIcon from "../../assets/icons/contacts/gmail.png";
import linkedinIcon from "../../assets/icons/contacts/linkedin.png";
import skypeIcon from "../../assets/icons/contacts/skype.png";
import githubIcon from "../../assets/icons/contacts/github.png";

const cv = require("../../assets/files/CV-fenohasina-jean-felicien-brillant.pdf");

// const cv = require("../../assets/files/CV-brillant.odt");
const downloadCV = () => {
  const a = document.createElement("a");
  a.href = cv;
  a.download = "cv-brillant.pdf";
  a.click();
};
const Contact = () => {
  const { l, changeLanguage } = useContext(LanguageContext);
  return (
    <div className="contact-container">
      <div
        className="contact-background"
        style={{ backgroundImage: `url(${coverImage})` }}
      ></div>

      <div className="contact-modal-container">
        <h3>{l.contact.thanks}</h3>
        <p>
          {l.contact.msg[0]}{" "}
          <a href="mailto:jbrillantf@gmail.com">{l.contact.msg[1]}</a>
        </p>

        <div className="actions-container">
          <button onClick={downloadCV}>{l.header.download}</button>
        </div>

        <hr />

        <div className="social-network-container">
          <div className="label">{l.contact.joinMe}</div>
          <div className="social-network-list">
            <a
              href="https://www.facebook.com/brillant.jeanfelicien.96"
              target="_blank"
            >
              <img src={facebookIcon} alt="facebook" />
            </a>

            <a href="mailto:jbrillantf@gmail.com" target="_blank">
              <img src={gmailIcon} alt="gmail" />
            </a>
            <a
              href="https://www.linkedin.com/in/fenohasina-jean-f%C3%A9licien-brillant-433474241/"
              target="_blank"
            >
              <img src={linkedinIcon} alt="linkedin" />
            </a>
            <a href="skype:live:.cid.10b6edffeca2cec1" target="_blank">
              <img src={skypeIcon} alt="skype" />
            </a>
            <a href="https://github.com/bri11ant" target="_blank">
              <img src={githubIcon} alt="github" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
